import { CampaignProvider } from '@superfunnel/types/agent-run';

import { ResolvedTheme } from './theme';

import applovinAdsDark from '@/assets/svgs/icons/oficialIcons/applovin-ads-dark.svg?no-inline';
import applovinAdsLight from '@/assets/svgs/icons/oficialIcons/applovin-ads-light.svg?no-inline';
import googleAds from '@/assets/svgs/icons/oficialIcons/google-ads.svg?no-inline';
import linkedinAds from '@/assets/svgs/icons/oficialIcons/linkedin-ads.svg?no-inline';
import metaAds from '@/assets/svgs/icons/oficialIcons/meta-ads.svg?no-inline';
import microsoftAds from '@/assets/svgs/icons/oficialIcons/microsoft.svg?no-inline';
import taboolaAds from '@/assets/svgs/icons/oficialIcons/taboola-ads.svg?no-inline';
import tiktokAdsDark from '@/assets/svgs/icons/oficialIcons/tiktok-ads-dark.svg?no-inline';
import tiktokAdsLight from '@/assets/svgs/icons/oficialIcons/tiktok-ads-light.svg?no-inline';

export type AdsPlatform = CampaignProvider | 'applovin';

const adsPlatformIcons: Record<AdsPlatform, Record<ResolvedTheme, string>> = {
  google: { light: googleAds, dark: googleAds },
  facebook: { light: metaAds, dark: metaAds },
  bing: { light: microsoftAds, dark: microsoftAds },
  linkedin: { light: linkedinAds, dark: linkedinAds },
  taboola: { light: taboolaAds, dark: taboolaAds },
  tiktok: { light: tiktokAdsLight, dark: tiktokAdsDark },
  applovin: { light: applovinAdsLight, dark: applovinAdsDark },
};

export const isAdsPlatform = (provider: string): provider is AdsPlatform =>
  Object.prototype.hasOwnProperty.call(adsPlatformIcons, provider);

export const getAdsPlatformIcon = (
  platform: AdsPlatform,
  theme: ResolvedTheme,
): string => {
  return adsPlatformIcons[platform][theme];
};

export const assetUrlToCDNUrl = (assetUrl?: string) => {
  if (!assetUrl) {
    return assetUrl;
  }

  if (
    assetUrl.startsWith(
      'https://firebasestorage.googleapis.com/v0/b/cyder-ai.appspot.com/o/',
    )
  ) {
    const url = new URL(
      assetUrl.replace(
        'https://firebasestorage.googleapis.com/v0/b/cyder-ai.appspot.com/o/',
        'https://cdn.superfunnel.ai/',
      ),
    );
    const path = decodeURIComponent(url.pathname);
    return `https://cdn.superfunnel.ai${path}`;
  }

  if (
    assetUrl.startsWith(
      'https://firebasestorage.googleapis.com/v0/b/ai-marketing-agents-406e0.firebasestorage.app/o/',
    )
  ) {
    const url = new URL(
      assetUrl.replace(
        'https://firebasestorage.googleapis.com/v0/b/ai-marketing-agents-406e0.firebasestorage.app/o/',
        'https://cdn.superfunnel.ai/',
      ),
    );
    const path = decodeURIComponent(url.pathname);
    return `https://cdn.superfunnel.ai${path}`;
  }

  return assetUrl;
};
